export const validatePhoneNumber = value => {
  if (value) {
    var cleanedValue =
      typeof value === "string" ? value.trim() : value.toString();
    const pattern = /^\+\d+$|^\d+$/;
    const isNumber = pattern.test(cleanedValue);
    if (
      isNumber &&
      ((cleanedValue.charAt(0) === "+" && cleanedValue.length > 5) ||
        (cleanedValue.charAt(0) !== "+" && cleanedValue.length > 4)) &&
      cleanedValue.length < 16
    ) {
      return true;
    }
  } else return true;

  return "Số điên thoại không hợp lệ";
};

var sanitize = require("sanitize-filename");
export const removeUnicodeCharacters  = function(str, max) {
  if (typeof str !== "string") {
    return "";
  }

  str = str.replace(/(á|à|ả|ã|ạ|ă|ắ|ằ|ẳ|ẵ|ặ|â|ấ|ầ|ẩ|ẫ|ậ)/g, "a");
  str = str.replace(/(A|À|Ả|Ã|Ạ|Ă|Ắ|Ằ|Ẳ|Ẵ|Ặ|Â|Ấ|Ầ|Ẩ|Ẫ|Ậ)/g, "A");
  str = str.replace(/đ/g, "d");
  str = str.replace(/Đ/g, "D");
  str = str.replace(/(é|è|ẻ|ẽ|ẹ|ê|ế|ề|ể|ễ|ệ)/g, "e");
  str = str.replace(/(É|È|Ẻ|Ẽ|Ẹ|Ê|Ế|Ề|Ể|Ễ|Ệ)/g, "E");
  str = str.replace(/(í|ì|ỉ|ĩ|ị)/g, "i");
  str = str.replace(/(Í|Ì|Ỉ|Ĩ|Ị)/g, "I");
  str = str.replace(/(ó|ò|ỏ|õ|ọ|ô|ố|ồ|ổ|ỗ|ộ|ơ|ớ|ờ|ở|ỡ|ợ)/g, "o");
  str = str.replace(/(Ó|Ò|Ỏ|Õ|Ọ|Ô|Ố|Ồ|Ổ|Ỗ|Ộ|Ơ|Ớ|Ờ|Ở|Ỡ|Ợ)/g, "O");
  str = str.replace(/(ú|ù|ủ|ũ|ụ|ư|ứ|ừ|ử|ữ|ự)/g, "u");
  str = str.replace(/(Ú|Ù|Ủ|Ũ|Ụ|Ư|Ứ|Ừ|Ử|Ữ|Ự)/g, "U");
  str = str.replace(/(ý|ỳ|ỷ|ỹ|ỵ)/g, "y");
  str = str.replace(/(Ý|Ỳ|Ỷ|Ỹ|Ỵ)/g, "Y");

  str = str.replace(/[^a-zA-Z0-9_-]/g, " ");

  while (str.length > 0 && /--/g.test(str)) {
    str = str.replace(/--/g, " ");
  }

  if (str) {
    str = sanitize(str);
    str = str.toLowerCase();

    const limit = max || 32;
    return str.substring(0, limit);
  }

  return "";
};

/**
 * Wrapper for localStorage
 */
function storageFactory() {
  let inMemoryStorage = {};
  let storage;

  function isSupported() {
    try {
      const key = "storage";
      storage = localStorage;
      storage.setItem(key, key);
      storage.removeItem(key);
      return true;
    } catch (e) {
      return false;
    }
  }

  function getItem(key) {
    if (isSupported()) {
      return storage.getItem(key);
    }
    return inMemoryStorage[key] || null;
  }

  function setItem(key, value) {
    if (isSupported()) {
      storage.setItem(key, value);
    } else {
      inMemoryStorage[key] = value;
    }
  }

  function removeItem(key) {
    if (isSupported()) {
      storage.removeItem(key);
    } else {
      delete inMemoryStorage[key];
    }
  }

  function clear() {
    if (isSupported()) {
      storage.clear();
    } else {
      inMemoryStorage = {};
    }
  }

  function key(n) {
    if (isSupported()) {
      return storage.key(n);
    } else {
      return Object.keys(inMemoryStorage)[n] || null;
    }
  }

  return {
    getItem,
    setItem,
    removeItem,
    clear,
    key
  };
}

const localStorageWrapper = storageFactory();
export const getItemStorage = function(key) {
  return localStorageWrapper.getItem(key);
};

export const setItemStorage = function(key, data) {
  localStorageWrapper.setItem(key, data);
};

export const removeItemStorage = function(key) {
  localStorageWrapper.removeItem(key);
};
/* End localStorage */
